import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReconciliationService } from '../reconciliation.service';

export interface BankTransactionImportData {
  bankId: string;
  bankTypeId: number;
  bankName?: string;
}

@Component({
    selector: 'convfact-bank-transaction-import',
    templateUrl: './bank-transaction-import.component.html',
    styleUrls: ['./bank-transaction-import.component.css'],
    standalone: false
})
export class BankTransactionImportImportComponent {

  private readonly bankId: string = this.data.bankId;
  private readonly bankTypeId: number = this.data.bankTypeId;

  public loading = false;
  public imported = false;
  public dragOver = false;
  public fileName = '';
  public errorMessage = '';

  static open(dialog: MatDialog, data: BankTransactionImportData) {
    return dialog.open<BankTransactionImportImportComponent, BankTransactionImportData, boolean>(BankTransactionImportImportComponent, {
      width: '560px',
      maxWidth: '96vw',
      maxHeight: '90vh',
      autoFocus: false,
      data,
    }).afterClosed();
  }

  constructor(
    public dialogRef: MatDialogRef<BankTransactionImportImportComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public data: BankTransactionImportData,
    protected reconciliationService: ReconciliationService,
  ) { }

  get subtitle(): string {
    return this.data.bankName || 'Sube los movimientos de tu banco con nuestra plantilla Excel';
  }

  public closeDialog(): void {
    if (this.loading) return;
    this.dialogRef.close(this.imported);
  }

  public onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.dragOver = true;
  }

  public onDrop(event: DragEvent): void {
    event.preventDefault();
    this.dragOver = false;
    const file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
    if (file) this.upload(file);
  }

  public fileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files && input.files[0];
    input.value = '';
    if (file) this.upload(file);
  }

  public reset(): void {
    this.imported = false;
    this.fileName = '';
    this.errorMessage = '';
  }

  public downloadTemplate(): void {
    window.open('https://drive.google.com/u/0/uc?id=1xdhi0Nr6kiEwOntk6vkyCb1pCqdPi3Ak&export=download', '_blank');
  }

  private upload(file: File): void {
    if (this.loading) return;

    if (!/\.xlsx$/i.test(file.name)) {
      this.errorMessage = 'El archivo debe ser un Excel (.xlsx) con el formato de la plantilla.';
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    formData.append('bankId', this.bankId);
    formData.append('bankTypeId', String(this.bankTypeId));

    this.fileName = file.name;
    this.errorMessage = '';
    this.loading = true;
    this.dialogRef.disableClose = true;

    this.reconciliationService.importTrasactions(formData)
      .then(() => { this.imported = true; })
      .catch(error => {
        this.errorMessage = (error && error.error && error.error.message)
          || 'No se pudo importar el extracto. Revisa que el archivo tenga el formato de la plantilla.';
      })
      .then(() => {
        this.loading = false;
        this.dialogRef.disableClose = false;
      });
  }
}
